import { makeStyles } from "tss-react/mui"
import { Button, Grid } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    button: {
        fontSize: "0.8rem",
        textTransform: "none",
        fontWeight: 500,
    },
    buttonPrimary: {
        color: "#2196f3",
    },
}))

type CreateUpdateDayMenuFormProps = Readonly<{
    title: string
    handleClick: () => void
    errorType?: boolean
}>

export function DayMenuAddButton({ title, handleClick, errorType = false }: CreateUpdateDayMenuFormProps) {
    const { classes, cx } = useStyles()

    return (
        <Grid>
            <Button
                variant="text"
                color={errorType ? "error" : "primary"}
                onClick={handleClick}
                className={cx(classes.button, { [classes.buttonPrimary]: !errorType })}
            >
                {title}
            </Button>
        </Grid>
    )
}
